class PopupManager {
    constructor(configuratorId) {
        this.configuratorId = configuratorId;
        this.popup = $('body .pc-configurator-popup[data-configurator-id="' + configuratorId + '"]');
        this.button = $('body .pc-configurator-button[data-configurator-id="' + configuratorId + '"]');
        this.closeButton = $('body .pc-configurator-close[data-configurator-id="' + configuratorId + '"]');
        this.isLoaded = false;
        this.hash = this.button.data('hash');
        this.ajaxManager = new AjaxManager();
    }

    init() {
        this.initPopupOpen();
        this.initPopupClose();
        // this.initOutsideClick();
    }

    initPopupOpen() { 
        this.button.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (this.isLoaded) {
                this.popup.fadeIn();
            } else {
                this.button.addClass('loading');
                this.loadPopupContent();
            }
        });
    }

    async loadPopupContent() {
        try {
            this.button.addClass('loading');
            
            const response = await this.ajaxManager.loadPopupContent(this.configuratorId, this.hash);
            
            if (response.success) {
                if (!this.popup.length) {
                    $('body').append(response.data.html);
                    this.popup = $('body .pc-configurator-popup[data-configurator-id="' + this.configuratorId + '"]');
                    this.closeButton = this.popup.find('.pc-configurator-close');
                    this.initPopupClose();
                    // this.initOutsideClick();
                } else {
                    this.popup.html($(response.data.html).html());
                }

                this.isLoaded = true;
                this.popup.fadeIn();
                
                if (window.productConfiguratorInstance) {
                    new OptionsManager(this.configuratorId);
                    new PriceCalculator();
                    new CartManager(this.configuratorId);
                    new QuantityManager(this.configuratorId);
                    new QuoteManager(this.configuratorId);
                }
            }
        } catch (error) {
            console.error('Error loading popup:', error);
            alert('Error loading configurator content');
        } finally {
            this.button.removeClass('loading');
        }
    }

    initPopupClose() {
        this.closeButton.on('click', () => {
            this.popup.fadeOut();
        });
    }

    initOutsideClick() {
        this.popup.on('click', (e) => {
            if ($(e.target).is('.pc-configurator-popup')) {
                this.popup.fadeOut();
            }
        });
    }
} 